/** @format */

//material ui
import React, { useContext } from "react";
import { useTheme } from "@mui/styles";
import { Typography, Box, useMediaQuery } from "@mui/material";

//json2mq
import json2mq from "json2mq";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";
import { ColorContext } from "../../pages/Bootcamp";

const CardsBenefitsMobile = () => {
  const { mainColor, secondaryColor } = useContext(ColorContext);

  const useStyles = (theme) => ({
    container: {
      display: "flex",
      flexDirection: { xs: "column" },
      alignItems: { xs: "center" },
      backgroundImage: `linear-gradient(to bottom, ${mainColor}12 0%, ${secondaryColor}03 100%);`,
      backgroundPosition: { xs: "center" },
      backgroundRepeat: "no-repeat",
      backgroundSize: "100% 1200px",
      height: { xs: "auto" },
      width: { xs: "100vw" },
    },
    firstCard: {
      display: "flex",
      flexDirection: { xs: "column" },
      alignItems: { xs: "center" },
      background: "linear-gradient(to bottom, #23213f 0%, #03183d 100%)",
      height: { xs: "410px" },
      width: { xs: "299px" },
      borderRadius: "47px",
      mt: { xs: "46px" },
    },
    firstTitle: {
      color: mainColor,
      fontSize: { xs: "26px" },
      lineHeight: { xs: "36px" },
      fontFamily: theme.typography.montserrat.bold,
      textAlign: { xs: "center" },
      mt: { xs: "34px" },
    },
    firstSubtitle: {
      color: theme.palette.blue.light,
      fontFamily: theme.typography.anaHeim.regular,
      fontSize: { xs: "24px" },
      lineHeight: { xs: "36px" },
      maxWidth: { xs: "287px" },
      height: { xs: "141px" },
      textAlign: { xs: "center" },
    },

    secondCard: {
      display: "flex",
      flexDirection: { xs: "column" },
      alignItems: { xs: "center" },
      background: theme.palette.white.main,
      height: { xs: "410px" },
      width: { xs: "299px" },
      borderRadius: "47px",
      mt: { xs: "46px" },
      boxShadow: "0 10px 50px 0 rgba(0, 0, 0, 0.05)",
    },

    secondTitle: {
      color: theme.palette.blue.main,
      fontSize: { xs: "26px" },
      lineHeight: { xs: "36px" },
      fontFamily: theme.typography.montserrat.bold,
      textAlign: { xs: "center" },
      mt: { xs: "17px" },
      height: { xs: "46px" },
    },
    secondSubtitle: {
      color: theme.palette.blue.main,
      fontFamily: theme.typography.anaHeim.regular,
      fontSize: { xs: "24px" },
      lineHeight: { xs: "36px" },
      maxWidth: { xs: "269px" },
      height: { xs: "222px" },
      textAlign: { xs: "center" },
    },
    thirdCard: {
      display: "flex",
      flexDirection: { xs: "column" },
      alignItems: { xs: "center" },
      background: theme.palette.white.main,
      height: { xs: "483px" },
      width: { xs: "299px" },
      borderRadius: "47px",
      mt: { xs: "46px" },
      boxShadow: "0 10px 50px 0 rgba(0, 0, 0, 0.05)",
    },

    thirdTitle: {
      color: theme.palette.blue.main,
      fontSize: { xs: "26px" },
      lineHeight: { xs: "36px" },
      fontFamily: theme.typography.montserrat.bold,
      textAlign: { xs: "center" },
      mt: { xs: "26.9px" },
    },
    thirdSubtitle: {
      color: theme.palette.blue.main,
      fontFamily: theme.typography.anaHeim.regular,
      fontSize: { xs: "24px" },
      lineHeight: { xs: "36px" },
      maxWidth: { xs: "275px" },
      height: { xs: "209px" },
      mt: { xs: "20px" },
      textAlign: { xs: "center" },
    },
  });

  const xs = useMediaQuery(
    json2mq({
      maxWidth: 899,
    })
  );

  const theme = useTheme();
  const classes = useStyles(theme);

  const stylesHelper = () => {
    if (xs)
      return {
        firstIcon: {
          width: "51px",
          height: "57px",
          color: theme.palette.blue.lightblue,
          marginTop: "58px",
        },
        secondIcon: {
          width: "64.8px",
          height: "65px",
          color: theme.palette.blue.lightblue,
          marginTop: "45px",
        },
        thirdIcon: {
          width: "57px",
          height: "52.1px",
          color: theme.palette.blue.lightblue,
          marginTop: "45px",
        },
      };
  };

  const { pathname } = useLocation();
  const componentName = "CardsBenefitsMobile";
  const translation = useTranslation(pathname, componentName);

  const { cards } = translation;

  return (
    <Box sx={classes.container}>
      {["first", "second", "third"].map((number, i) => (
        <Box sx={classes[`${number}Card`]} key={number}>
          {cards[i].img && (
            <img
              src={cards[i].img.src}
              alt={cards[i].img.alt}
              style={stylesHelper() && stylesHelper()[`${number}Icon`]}
            />
          )}
          <Typography sx={classes[`${number}Title`]}>
            {cards[i].title}
          </Typography>
          <Typography sx={classes[`${number}Subtitle`]}>
            {cards[i].subtitle}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CardsBenefitsMobile;
